export interface BasePdsProps {
   /**
   * A unique identifier used for the underlying component `id` attribute.
   */
  componentId: string;
}
